<template>
  <v-container fluid class="pa-6">
    <v-row justify="center">
        <v-col cols="12" lg="12" xl="8">
            <v-card elevation="4" class="rounded-lg">
                <v-card-title class="bg-primary text-white text-h5 text-center py-4">
                    Add Leave Application
                </v-card-title>
          
                <v-container fluid>
                  <div class="scroll-row">
                    <v-card
                      v-for="(leave, idx) in getLeaveBalance"
                      :key="idx"
                      class="balance-card pa-5 rounded"
                      elevation="3"
                    >
                      <v-row align="center" justify="center">
                        <v-col cols="12">
                          <div class="title text-dark text-center">{{ leave.leave_type_name }}</div>
                          <div class="display-1  text-center text-dark">
                           Total: <span class="font-weight-bold">{{ leave.entitled_days }}</span>, Used: <span class="font-weight-bold">{{ leave.used_days }}</span>, Remaining: <span class="font-weight-bold">{{ leave.remaining_days }}</span>
                          </div>
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                </v-container>


                <v-card-text class="pa-6">
                    <v-form ref="leaveApplicationForm" @submit.prevent="submit">
                         <v-row class="mb-4">

                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="employee.value.value"
                                    variant="outlined"
                                    label="Select Employee"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    :loading="loading"
                                    :items="getHrmEmployeeList"
                                    :item-title="(item) => `${item.code}-${item.name}` ?? 'N/A'"
                                    :error-messages="employee.errorMessage.value"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-account"
                                    item-value="id"
                                    clearable
                                    ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4">
                                <v-autocomplete
                                    v-model="leave_type.value.value"
                                    variant="outlined"
                                    label="Select Leave Type"
                                    density="compact"
                                    bg-color="grey-lighten-4"
                                    :loading="loading"
                                    :items="getLeaveTypeList"
                                    :item-title="(item) => `${item.name ?? 'N/A'}`"
                                    :error-messages="leave_type.errorMessage.value"
                                    prepend-icon=""
                                    prepend-inner-icon="mdi-account"
                                    item-value="id"
                                    clearable
                                    ></v-autocomplete>
                            </v-col>

                            <v-col cols="12" md="4" class=" align-center" style="gap:0;">
                              <v-date-input v-model="start_date.value.value" label="Start Date *" variant="outlined" density="compact" :error-messages="start_date.errorMessage.value" prepend-icon="" prepend-inner-icon="mdi-calendar"></v-date-input>
                              <v-radio-group v-if="getLeaveTypeDetails?.half_day_allow==1" v-model="start_day_status.value.value"  :error-messages="start_day_status.errorMessage.value" color="primary" density="compact" inline class="ma-0 pa-0">
                                <v-radio class="ma-0 pa-0 mr-3" label="First Half" value="first_half"></v-radio>
                                <v-radio class="ma-0 pa-0" label="Second Half" value="second_half"></v-radio>
                              </v-radio-group>
                            </v-col>

                             <v-col cols="12" md="4">
                                <v-date-input v-model="end_date.value.value" label="End Date *" variant="outlined" density="compact" :error-messages="end_date.errorMessage.value" prepend-icon="" prepend-inner-icon="mdi-calendar"
                                ></v-date-input>

                                <v-radio-group v-if="getLeaveTypeDetails?.half_day_allow==1" v-model="end_day_status.value.value" :error-messages="end_day_status.errorMessage.value" color="primary" density="compact" inline class="ma-0 pa-0">
                                  <v-radio class="ma-0 pa-0 mr-3" label="First Half" value="first_half"></v-radio>
                                  <v-radio class="ma-0 pa-0" label="Second Half" value="second_half"></v-radio>
                                </v-radio-group>
                            </v-col>

                            <v-col cols="4">
                              <v-text-field
                                label="Total Day(s)"
                                density="compact"
                                variant="outlined"
                                bg-color="grey-lighten-4"
                                v-model="getLeaveDayCount"
                                readonly
                              ></v-text-field>
                            </v-col>

                            <v-col cols="4">
                                <v-textarea
                                    label="Reason"
                                    density="compact"
                                    variant="outlined"
                                    bg-color="grey-lighten-4"
                                    v-model="reason.value.value"
                                    :error-messages="reason.errorMessage.value"
                                    clearable
                                    rows="1"
                                ></v-textarea>
                            </v-col>
                            <v-col cols="4">
                                <v-text-field
                                    label="Supervisor"
                                    density="compact"
                                    variant="outlined"
                                    bg-color="grey-lighten-4"
                                    :model-value="getHodName"
                                    readonly
                                    disabled
                                    rows="1"
                                ></v-text-field>
                            </v-col>
                         </v-row>
                         <v-row>
                          <v-col cols="12">
                            <p class="text-center font-medium text-h6"
                                style="background-color: #d4edda; border-radius: 8px; padding: 12px;"
                              >
                                Assigned Person Information
                              </p>
                          </v-col>

                          <!-- <v-col cols="12" md="4">
                              <v-autocomplete
                                  v-model="department.value.value"
                                  variant="outlined"
                                  label="Select Department"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  :loading="loading"
                                  :items="getHrmDepartmentList"
                                  :item-title="(item) => `${item.name ?? 'N/A'}`"
                                  :error-messages="department.errorMessage.value"
                                  prepend-icon=""
                                  prepend-inner-icon="mdi-account"
                                  item-value="id"
                                  clearable
                                  ></v-autocomplete>
                          </v-col> -->
                          <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="re_leaver.value.value"
                                variant="outlined"
                                label="Assigned Person *"
                                density="compact"
                                bg-color="grey-lighten-4"
                                :loading="loading"
                                :items="getDepartmentWiseEmployeeList"
                                :item-title="(item) => `${item.code}-${item.name}-${item?.department?.name}` ?? 'N/A'"
                                :error-messages="re_leaver.errorMessage.value"
                                prepend-icon=""
                                prepend-inner-icon="mdi-account"
                                item-value="id"
                                clearable
                                ></v-autocomplete>
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-text-field
                              label="Designation"
                              density="compact" 
                              variant="outlined"
                              bg-color="grey-lighten-4"
                              :model-value="designation"
                              readonly
                              disabled
                              rows="1"
                            ></v-text-field>
                          </v-col>
                        </v-row>
                        <v-card-actions class="justify-end mt-4 pa-4">
                
                            <v-btn
                                color="grey"
                                variant="flat"
                                type="button"
                                size="large"
                                @click="submitForm(0)"
                                :loading="loading"
                                >
                                DRAFT
                            </v-btn>

                            <v-btn
                                color="primary"
                                variant="flat"
                                type="button"
                                size="large"
                                @click="submitForm(1)"
                                :loading="loading"
                            >
                                POST
                            </v-btn>
                        </v-card-actions>
                    </v-form>
                </v-card-text>

            </v-card>
        </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ref, computed , watch } from "vue";
import { toast } from "vue3-toastify";
import { useForm, useField } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import formattedDate from "@/plugins/dateFormatter";

export default {
  name: "JournalVoucherEntry",

  data: () => ({
    loading: false,
  }),

  created() {
        this.$store.commit("UNSET_EMPLOYEE_LEAVE_BALANCE_LIST");
        if(this.$store.getters.getLeaveTypeList.length == 0){
            this.loading = true;
            this.$store.dispatch('getLeaveTypeList').then((response) => {
                this.loading = false;
            })
        };

         if(this.$store.getters.getHrmDepartmentList.length == 0){
              this.loading = true;
              this.$store.dispatch('getHrmDepartmentList').then((response) => {
                  this.loading = false;
              })
          };

         if(this.$store.getters.getHrmEmployeeList.length == 0){
            this.loading = true;
            this.$store.dispatch('getHrmEmployeeList').then((response) => {
                this.loading = false;
            })
        };

        this.$store.dispatch("getDepartmentWiseEmployeeList", {department_id: null})

        
  },

  computed: {
    getLeaveTypeList() {
        return this.$store.getters.getLeaveTypeList;
    },
    getHrmDepartmentList(){
      return this.$store.getters.getHrmDepartmentList;
    },
    getHrmEmployeeList(){
        return this.$store.getters.getHrmEmployeeList;
    },
    getDepartmentWiseEmployeeList() {
      return this.$store.getters.getDepartmentWiseEmployeeList;
    },
     getLeaveDayCount() {
        return this.$store.getters.getLeaveDayCount;
    },
    getLeaveTypeDetails() {
        return this.$store.getters.getLeaveTypeDetails;
    },
    getLeaveBalance() {
      const list = this.$store.getters.getEmployeeLeaveBalanceList;
      const leave_balances = list && list.length > 0 ? list[0].leave_balances : [];
      return leave_balances;
    },
    getHodName(){
        //return this.$store.getters.getEmployeeDetails?.hod?.name || '';
        return `${this.$store.getters.getEmployeeDetails?.hod?.code ?? ''}-${this.$store.getters.getEmployeeDetails?.hod?.name ?? ''}`;
    },
  },

  methods: {
  },

  setup() {

    const store = useStore();

    const { handleSubmit, resetForm, setFieldValue } = useForm({
      validationSchema: yup.object({
        leave_type: yup.number().required().label("Leave Type"),
        start_date: yup.date().required().label("Start Date"),
        end_date: yup.date().required().label("End Date"),
        start_day_status: yup.string().nullable().label("Start Day Status"),
        end_day_status: yup.string().nullable().label("End Day Status"),
        //reason: yup.string().required().label("reason"),
        department: yup.number().nullable().label("Department"),
        re_leaver: yup.number().required().nullable().label("Assigned Person"),
        employee: yup.number().required().label("Employee"),
        
      }),
    });

    const submitForm = (status) => {
      setFieldValue('status', status);
      submit();                       
    };

    const leave_type = useField("leave_type");
    const start_date = useField("start_date");
    const end_date = useField("end_date");
    const start_day_status = useField("start_day_status");
    const end_day_status = useField("end_day_status");
    const reason = useField("reason");
    const choice = useField("choice");
    const department = useField("department");
    const re_leaver = useField("re_leaver");
    const employee = useField("employee");
    
    

    const isEntryMode = ref(true);
    const loading = ref(false);
    const router = useRouter();
    const designation = ref('');

    watch( () => leave_type.value.value, (leave_type_id) => {
      if (leave_type_id) {
        store.dispatch("getLeaveTypeDetails", leave_type_id);
      }
    },
      { immediate: false }
    );

    watch(() => re_leaver.value.value, (id) => {
      const getDepartmentWiseEmployeeList = store.getters.getDepartmentWiseEmployeeList;
      const emp = getDepartmentWiseEmployeeList.find(e => e.id === id);
      designation.value = emp?.designation?.name ?? '';
    });


    watch( () => employee.value.value, (employee_id) => {
      if (employee_id) {
        store.dispatch("getEmployeeLeaveBalanceList", {employee_id:employee_id});
        store.dispatch("getEmployeeDetails", employee_id);
      }
    },
      { immediate: false }
    );


    watch( () => department.value.value, (newDepartment) => {
        // if (newDepartment) {
          store.dispatch("getDepartmentWiseEmployeeList", {
            department_id: newDepartment,
          });
          re_leaver.value.value = null;
        // }else{
        //   re_leaver.value.value = null;
        // }
      },
      { immediate: false }
    );

    watch(
      [
        () => leave_type.value.value,
        () => start_date.value.value,
        () => start_day_status.value.value,
        () => end_date.value.value,
        () => end_day_status.value.value,
      ],
      ([leave_type_id, start_date_val, start_day_status_val, end_date_val, end_day_status_val]) => {

        const start = new Date(start_date_val)
        const end = new Date(end_date_val)
        if (start > end) {
          toast.error("Invalid date range.");
          return;
        }

        if (
          leave_type_id &&
          start_date_val &&
          end_date_val
        ) {
          store.dispatch("getLeaveDayCount", {
            leave_type_id: leave_type_id,
            start_date: start_date_val,
            start_day_status: start_day_status_val,
            end_date: end_date_val,
            end_day_status: end_day_status_val,
          });
          re_leaver.value.value = null;
        } else {
          re_leaver.value.value = null;
        }
      },
      { immediate: false }
    );



    const submit = handleSubmit((values) => {
      const start = new Date(formattedDate(start_date.value.value));
      const end = new Date(formattedDate(end_date.value.value));
      if (start > end) { toast.error("Invalid date range.");return; }
      loading.value = true;
      const payload = {
        leave_type_id: leave_type.value.value,
        start_date: formattedDate(start_date.value.value),
        start_day_status: start_day_status.value.value,
        end_date: formattedDate(end_date.value.value),
        end_day_status: end_day_status.value.value,
        reason:reason.value.value,
        status: values.status,
        department_id: department.value.value,
        re_leaver_id: re_leaver.value.value,
        employee_id:employee.value.value,
      };
      store
        .dispatch("saveUpdateLeave", payload)
        .then((response) => {
          resetForm();
          loading.value = false;
          toast.success(response.data.message, {
            timeout: 2000,
          });
          store.dispatch("getLeaveList");
          router.push({ name: "dyeing-order-record" });
        })
        .catch((error) => {
          toast.error(
            error.response?.data?.message || "Failed to save voucher"
          );
        })
        .finally(() => {
          loading.value = false;
        });
    });

    return {
      submit,
      submitForm,
      leave_type,
      start_date,
      end_date,
      start_day_status,
      end_day_status,
      reason,
      choice,
      loading,
      isEntryMode,
      department,
      re_leaver,
      employee,
      designation,
    };
  },

  mounted() {
    const queryId = this.$route.query.id;
    // If editing an existing voucher
    if (this.$store.getters.editingLeave && queryId) {
      const leave = this.$store.getters.editingLeave;

      this.leave_type.value.value = leave?.leave_type_id;
      this.employee.value.value = leave?.employee_id;
      this.start_date.value.value = leave?.start_date;
      this.start_day_status.value.value = leave?.start_day_status;
      this.end_date.value.value = leave?.end_date;
      this.end_day_status.value.value = leave?.end_day_status;
      this.reason.value.value = leave?.reason;
      this.department.value.value = leave?.department_id;

      if (leave?.department_id) {
        this.$store
          .dispatch("getDepartmentWiseEmployeeList", {
            department_id: leave.department_id,
          })
          .then(() => {
            this.re_leaver.value.value = leave?.re_leaver_id || "";
          });
      } else {
        this.re_leaver.value.value = null;
      }
    }
  }

};
</script>

<style scoped>
  .scroll-row {
    display: flex;
    gap: 15px;
    overflow-x: auto;
    padding-bottom: 10px;
  }

  .balance-card {
    min-width: 200px; /* same line রাখার জন্য দরকার */
    flex-shrink: 0;   /* shrink হতে দেবে না */
  }
</style>